import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19000fe4&scoped=true&lang=html&"
import script from "./customGoodsList.js?vue&type=script&lang=js&"
export * from "./customGoodsList.js?vue&type=script&lang=js&"
import style0 from "./customGoodsList.styl?vue&type=style&index=0&id=19000fe4&lang=stylus&scoped=true&"
import style1 from "./resetStyle.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19000fe4",
  null
  
)

export default component.exports